export default __webpack_public_path__ + "static/media/deliro.89b5f966.svg";